import rgba from "../../functions/rgba";

export default function card({ colors, borders, boxShadows }) {
  const { black, background } = colors;
  const { borderWidth, borderRadius } = borders;
  const { md } = boxShadows;

  const card = {
    styleOverrides: {
      root: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        minWidth: 0,
        wordWrap: "break-word",
        backgroundColor: background.paper,
        backgroundClip: "border-box",
        border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
        borderRadius: borderRadius.xl,
        boxShadow: md,
        overflow: "visible",
      },
    },
  };

  return card;
}
